export enum GeneralStatuses {
  IN_PROGRESS = 'in_progress',
  UNDER_ANALYSIS = 'under_analysis',
  APPROVED = 'approved',
  TO_REVIEW = 'to_review',
  WAITING_CUSTOMER = 'waiting_customer',
  REPROVED = 'reproved',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
}

type ProposalSteps = 'biometry_and_contract' | 'equipment' | 'customer_data' | 'payment_model'

export type ProposalStatus = Record<ProposalSteps, GeneralStatuses>
export type FormalizationStatus = Record<'contract' | 'hardware' | 'registration' | 'documentation' | 'receipt_model', GeneralStatuses>

export interface Item {
  name: string
  value: string
}

export interface FinancingList {
  all_steps: Item[]
  data: FinancingListItem[]
  total: number
  statuses: FinancingStatus[]
}

export type FinancingStatus
  = | 'approved'
    | 'canceled'
    | 'expired'
    | 'in_progress'
    | 'reproved'
    | 'to_review'
    | 'under_analysis'
    | 'waiting_customer'

type FinancingItemSteps
  = | 'biometry_and_contract'
    | 'customer_data'
    | 'equipment'
    | 'installation'
    | 'payment_model'
    | 'simulation'

export interface FinancingListItem {
  id: number
  project_id: string
  financed_value: number
  customer_name: string
  document?: string
  expires_at: string | null
  created_at: string
  formalized_at: string | null
  installed_at: string | null
  status: GeneralStatuses
  step: FinancingItemSteps
  is_combo: boolean
  is_combo_connect?: boolean | null
  payments: FinancingPayment[]
  percentage_paid?: number
  flow_provider: string
  person_type: string
  all_payments_sent: boolean
  section_statuses?: {
    concluded: string
    simulation: string
    installation: string
    formalization: {
      contract: string
      hardware: string
      registration: string
      documentation: string
      receipt_model: string
    }
    proposal: ProposalStatus
  }
  updated_at?: string | null
  is_expired?: boolean
  system_power: number
  reason: string
}

export interface FinancingPayment {
  id: number
  financing_id: number
  value: number
  created_at: string
}

interface Filters {
  id: string
  class: string
  placeholder: string
  size: string
  name: string
  label: string
  options: { name: string, value: string }[]
  selected: { name: string, value: string }
}

export interface OptionsFilters {
  title: string
  filters: Filters[]
}

export interface FinancingListParams {
  page: number
  page_size: number
  order_by: string
  query?: string
  steps?: string | Array<string>
  status?: string
  provider?: string
}

export interface FilterField {
  name: string
  value: string
}

export interface SelectedFilters {
  status?: FilterField | Array<FilterField> | string
  steps?: FilterField | Array<FilterField> | string
}

export interface FilterOptions {
  steps: Array<{ value: string, name: string }> | []
  status: Array<{ value: string, name: string }> | []
}

// Mapeamento de quais status são válidos para cada step
export const STEP_STATUS_MAPPING: Record<string, string[]> = {
  simulation: ['approved', 'reproved', 'expired', 'canceled'],
  customer_data: ['to_review', 'expired', 'canceled', 'in_progress', 'under_analysis', 'reproved'],
  equipment: ['in_progress', 'canceled', 'expired', 'under_analysis', 'approved', 'to_review'],
  biometry_and_contract: ['reproved', 'in_progress', 'to_review', 'under_analysis', 'canceled', 'waiting_customer', 'expired'],
  payment_model: ['to_review', 'in_progress', 'under_analysis', 'reproved', 'canceled', 'expired'],
  installation: ['to_review', 'in_progress', 'approved', 'canceled', 'expired', 'reproved', 'under_analysis'],
}
